import React from 'react';
import { Button } from 'components';
import { CheckIcon, CheckWhiteIcon, CloseIcon, DownloadIcon, LocationIcon } from 'assets/icons';
import moment from 'moment';
import { Globals, Constants, Socket, SocketEvents } from 'utils';
import { WhiteImage } from 'assets/img';

interface Props {
  onClose?: () => void;
  item?: any;
  states?: any;
  onApprove?: (item: any) => void;
  onReject?: (item: any) => void;
}

class ModalViewSeller extends React.Component<Props> {

    state = this.props.states;
  
  downloadDocument = (documentUrl: string, documentName: string) => {
    // Implementar lógica de descarga
    // Puede ser usando window.open o generando un link temporal
    if (documentUrl) {
      const link = document.createElement('a');
      link.href = documentUrl;
      link.download = documentName || 'documento';
      link.target = '_blank';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  }

  renderDocuments = () => {
    const { item } = this.props;
    console.log("ITEMS: ", item )
    
    // Asumiendo que los documentos vienen en un array o son propiedades específicas
    const documents = [
      { label: 'Documento de Identidad', url: item?.document_file, name: 'documento_identidad.pdf' },
      { label: 'Comprobante de Domicilio', url: item?.address_proof_file, name: 'comprobante_domicilio.pdf' },
      { label: 'Curriculum Vitae', url: item?.cv_file, name: 'curriculum.pdf' },
      // Agregar más documentos según tu estructura de datos
    ];

    return (
      <div className="documents-section">
        <h4>Documentos Adjuntos</h4>
        <div className="documents-list">
          {documents.map((doc, index) => {
            if (!doc.url) return null;
            
            return (
              <div key={index} className="document-item">
                <span>{doc.label}: </span>
                <Button 
                  type="button" 
                  className="btn-download"
                  onClick={() => this.downloadDocument(doc.url, doc.name)}
                >
                  <img src={DownloadIcon} alt="Descargar" />
                  Descargar
                </Button>
              </div>
            );
          })}
        </div>
      </div>
    );
  }

  render() {
    const { item, onClose, onApprove, onReject } = this.props;
    const isUnderReview = item?.verification !== Constants.USER.VERIFICATION.PENDING ? false : true;

    return (
      <div id="modal-view-seller" className='px-3 pb-4 position-relative'>
        <div className="header">
          <div>
            <p className="title">{ item?.name }</p>
            <p><b>Fecha de registro: </b> {item?.created_at && moment(item.created_at).format('DD-MM-YYYY')} </p>
          </div>
          <button className="close" onClick={onClose}>
            <img src={CloseIcon} alt="Cerrar" />
          </button>
        </div>
        <div className="row px-3">
          <div className='col-12'>
            <div className='row border border-success' style={{ "borderRadius": "10px" }}>
              <div className='col-4 bg-ctl p-2 border border-success' style={{ "borderTopLeftRadius": "10px", "borderBottomLeftRadius": "10px"}}>
                <h6 className=' text-ct' style={{"fontWeight": "bold"}}>CI/RIF</h6>
                <p>{item?.document_type?.name} {item?.document}</p>
              </div>
              <div className='col-4 bg-ctl p-2 border border-success'>
                <h6 className=' text-ct' style={{"fontWeight": "bold"}}>Telefono</h6>
                <p>{item?.phonecode?.name}-{item?.phone}</p>
              </div>
              <div className='col-4 bg-ctl p-2 border border-success' style={{ "borderTopRightRadius": "10px", "borderBottomRightRadius": "10px"}}>
                <h6 className=' text-ct' style={{"fontWeight": "bold"}}>Correo</h6>
                <p>{item?.email}</p>
              </div>
            </div>
          </div>

          <div className='col-4 mt-3'>
            <h6 className=' text-ct' style={{"fontWeight": "bold"}}>Cudad</h6>
            <p> { item?.city?.name } </p>
          </div>
          <div className='col-4 mt-3'>
            <h6 className=' text-ct' style={{"fontWeight": "bold"}}>Estado</h6>
            <p> { item?.state?.name } </p>
          </div>

          <div className='col-12 d-flex flex-column justify-content-start align-items-start'>
            <h6 style={{ "fontWeight": "bold" }} className='text-ct'>Cedula</h6>
            <div className='d-flex justify-content-start w-auto bg-ctm p-2' style={{ "borderRadius": "10px" }}>
              <img style={{ "borderRadius": "10px" }} height={50} src={ item?.document_file ? (Constants.BASE_STORAGE + item?.document_file) : WhiteImage }  alt="Documento" />
            </div>
          </div>

          <p className="mt-4 mb-0"><b>Datos bancarios</b></p>
          <div className='col-12 mb-4'>
            <div className='row border border-success' style={{ "borderRadius": "10px" }}>
              <div className='col-4 bg-ctl p-2 border border-success' style={{ "borderTopLeftRadius": "10px", "borderBottomLeftRadius": "10px"}}>
                <h6 className=' text-ct' style={{"fontWeight": "bold"}}>{ item?.bank_account?.bank?.name }</h6>
                <p>{item?.bank_account?.number}</p>
              </div>
              <div className='col-4 bg-ctl p-2 border border-success'>
                <h6 className=' text-ct' style={{"fontWeight": "bold"}}>Cédula</h6>
                <p>{item?.bank_account?.document_format}</p>
              </div>
              <div className='col-4 bg-ctl p-2 border border-success' style={{ "borderTopRightRadius": "10px", "borderBottomRightRadius": "10px"}}>
                <h6 className=' text-ct' style={{"fontWeight": "bold"}}>Teléfono</h6>
                <p>{item?.bank_account?.phone_format}</p>
              </div>
            </div>
          </div>
        </div>

        {isUnderReview && (
          <div className="actions">
            <button className="btn-success" onClick={onApprove}>
              <img src={ CheckWhiteIcon } alt="Aprobar" />
              <span>Aprobar</span>
            </button>

            <button className="btn-danger" onClick={onReject}>
              <img src={ CloseIcon } alt="Rechazar" />
              <span>Rechazar</span>
            </button>
          </div>
        )}
      </div>
    );
  }
}

export default ModalViewSeller;